import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {remCalc} from '../../theme/_utils'
import GenericModal from './generic-modal'
import {Text, VStack} from '@salesforce/retail-react-app/app/components/shared/ui'
import {AlertIcon} from '../icons'

export const ErrorModal = ({isOpen, onClose, error = null, message = null}) => {
    if (error) console.error(error)

    const messageContent = message || (
        <FormattedMessage
            id="checkout.modal.error_message"
            defaultMessage="An error occurred while processing your payment. Please try again."
        />
    )

    return (
        <GenericModal isOpen={isOpen} onClose={onClose} width={remCalc(450)}>
            <VStack spacing={remCalc(18)} padding={remCalc(24)} id="error-modal">
                <AlertIcon color="text.danger" marginTop={remCalc(42)} />
                <FormattedMessage id="checkout.modal.error" defaultMessage="Error" />
                <VStack spacing={remCalc(24)} textAlign="center">
                    <Text>{messageContent}</Text>
                </VStack>
            </VStack>
        </GenericModal>
    )
}

ErrorModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    error: PropTypes.object,
    message: PropTypes.node,
}
